import { SVGIconComponent } from '../../../../ui/components/pure/icons/types';
import { mapTransactionTypesToIcons } from '../../../deliveries/maps/kiosk-transaction-types-to-icons.map';
import { CarrierDto } from '@groundfloor-platform/mgmt-service-g-sdk';

/** One icon per delivery type, with the transaction types behind it as its hover text. */
export type CarrierCapabilityIcons = {
  SVGs: SVGIconComponent[];
  tooltips: string[];
};

/** Seven delivery types, so the cell's own "N+" overflow should never be reached. */
export const MAX_CAPABILITY_ICONS = 7;

/**
 * Capabilities as the delivery-type icons the UI already uses. Not an inline accessor because the
 * cell wants two parallel arrays and `mapTransactionTypesToIcons` returns one array of records.
 *
 * Empty is a real answer: a carrier granted nothing here. It renders as an empty cell.
 */
export function makeCarrierCapabilityIcons(carrier: CarrierDto): CarrierCapabilityIcons {
  const icons = mapTransactionTypesToIcons(carrier.capabilities || []);

  return {
    SVGs: icons.map((icon) => icon.Icon),
    tooltips: icons.map((icon) => icon.transactionTypeLabels.join(', '))
  };
}
